import { render } from "./ticket-details-modal.vue?vue&type=template&id=3b4dbc96"
import script from "./ticket-details-modal.vue?vue&type=script&lang=js"
export * from "./ticket-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__